export const TERMS_OF_SERVICE = "";

export const METAMASK_URL = "https://metamask.io/download";

export const HERO_YOUTUBE_URL = "https://www.youtube.com/embed/K2-xEFvQGu8";

export const HOW_TO_BUY_VIDEO = "https://www.youtube.com/embed/6qBnwAMLzuA?autoplay=1";
